import React, { FC, useRef, useState } from 'react';
// import { FiLogOut } from 'react-icons/fi';
import { RGBColor } from 'react-color';

import Modal from 'react-modal';
import { IMaskInput } from 'react-imask';

// import { Link } from 'react-router-dom';
import { Container, CustomLink, ModalTitle } from './styles';

import { useAuth } from '../../hooks/Auth';

import editButton from '../../assets/edit2.svg';
import { ReactComponent as SwapHoriz } from '../../assets/swap.svg';
import { ReactComponent as PersonIcon } from '../../assets/person.svg';
import { useFight } from '../../hooks/Fight';
import { useActions } from '../../hooks/Actions';
import { winnerNewIdFromAction } from '../../utils/fightResult';
import Button from '../Button';
import { ModalContent } from '../../pages/Scout/styles';

import fightApiV2 from '../../services/fightApiV2';
import mikeApi from '../../services/api';
import { Styles } from 'react-modal';
import { toast } from 'react-toastify';

interface RightHeaderProps {
  bgColor: RGBColor;
  color: string;
  eventName: string;
  isScout: boolean;
  hasLogout: boolean;
}

const RightHeader: FC<RightHeaderProps> = ({
  bgColor,
  color,
  eventName,
  hasLogout,
}) => {
  const { fight, updateFight } = useFight();
  const { actions, fetchActions } = useActions();
  const { token, signOut } = useAuth();
  const [modalIsOpen, setIsOpen] = useState(false);
  const [modalIsOpenSwap, setIsOpenSwap] = useState(false);
  const updateTime = useRef<HTMLInputElement>(null);

  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      background: '#fff',
      zIndex: 100,
      width: '50%',
      maxWidth: '800px',
      minWidth: '600px',
      // height: '60%',
      color: '#111',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-around',
      borderRadius: '16px',
    },
    overlay: {
      background: 'rgba(49, 46, 56, 0.80)',
    },
  };

  const handleEditTempo = () => {
    const time = updateTime.current?.value?.split(':');
    if (time) {
      updateFight({
        currentMinutes: +time[0],
        currentSeconds: +time[1],
      });
      setIsOpen(false);
    }
  };

  const handleModalOpen = () => {
    setIsOpen(true);
  };
  const handleCloseModal = () => {
    setIsOpen(false);
  };
  const handleModalSwapOpen = () => {
    setIsOpenSwap(true);
  };
  const handleCloseModalSwap = () => {
    setIsOpenSwap(false);
  };

  const handleSwapFighters = async () => {
    const data = {
      redCornerId: fight.blueCornerId,
      blueCornerId: fight.redCornerId,
    };

    // O vencedor troca de canto junto com os lutadores. O backend inverte os
    // ids sozinho; aqui só precisamos dizer o nome correspondente. A comparação
    // é pelo UUID: por legado, uma luta sem mapeamento dava sempre o mesmo nome.
    const resultAction = actions.find((action) => action.name === 'fightResult');
    const winnerNewId = winnerNewIdFromAction(resultAction, fight);
    const winnerName =
      winnerNewId === fight.redCornerId
        ? fight.blueCornerName
        : fight.redCornerName;

    const swapPayload = {
      redCornerId: fight.legacyRedCornerId,
      blueCornerId: fight.legacyBlueCornerId,
      redCornerNewId: fight.redCornerId,
      blueCornerNewId: fight.blueCornerId,
      winnerName: winnerName || '',
    };

    // Os slots trocam de dono junto com os cantos. O UUID vai junto: sem ele o
    // outcome continuaria casando com o lutador antigo em lutas sem legacyId.
    const { fightersOutcome } = fight;
    const [first, second] = fightersOutcome;
    const firstIsRed = first.fighterNewId
      ? first.fighterNewId === fight.redCornerId
      : first.fighterId === fight.legacyRedCornerId;

    const red = { fighterId: fight.legacyRedCornerId ?? null, fighterNewId: fight.redCornerId };
    const blue = { fighterId: fight.legacyBlueCornerId ?? null, fighterNewId: fight.blueCornerId };

    Object.assign(first, firstIsRed ? blue : red);
    Object.assign(second, firstIsRed ? red : blue);

    try {
      const response = await fightApiV2.patch(`/fights/${fight.id}`, data);

      if (response?.status === 200 || response?.status === 202) {
        // Endpoint dedicado: inverte authorId/targetId de todas as ações da
        // luta e ajusta o vencedor. Antes chamava `/actions/:id`, cujo `:id` é
        // o `_id` de UMA action — nunca casava e o swap não era propagado.
        // Best-effort: a v2 acima é a fonte de verdade; uma falha da v1 em
        // desativação não pode transformar um swap bem-sucedido em erro.
        try {
          await mikeApi.patch(`/fights/${fight.id}/swap-fighters`, swapPayload, {
            headers: {
              Authorization: token,
            },
          });
        } catch (legacyError) {
          console.warn(
            '[legacy-mike] swap-fighters não propagado à v1',
            legacyError,
          );
        }


        fetchActions();
      }

      toast.success('Lutadores invertidos com sucesso');
    } catch (error) {
      toast.error('Erro ao inverter lutadores: ' + error);
    }

    updateFight({
      redCornerId: fight.blueCornerId,
      blueCornerId: fight.redCornerId,
      legacyRedCornerId: fight.legacyBlueCornerId,
      legacyBlueCornerId: fight.legacyRedCornerId,
      redCornerName: fight.blueCornerName,
      blueCornerName: fight.redCornerName,
      fightersOutcome,
    });

    setIsOpenSwap(false);
  };

  return (
    <Container r={bgColor.r} g={bgColor.g} b={bgColor.b} color={color}>
      <div className="event-name">
        <span>{eventName}</span>
      </div>

      <div className="close-logout">
        {hasLogout && (
          // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
          <div onClick={() => signOut()}>
            <span>Sair</span>
          </div>
        )}
        {!hasLogout && (
          // baixar icon https://fonts.google.com/icons?selected=Material+Symbols+Outlined:swap_horiz:FILL@0;wght@400;GRAD@0;opsz@24&icon.query=swap&icon.size=24&icon.color=%23e8eaed
          <Button className="edit-button" onClick={() => handleModalSwapOpen()}>
            <div>
              <div className="left-person">
                <PersonIcon />
              </div>
              <div className="left-arrow">
                <SwapHoriz />
              </div>
              <div className="right-person">
                <PersonIcon />
              </div>
            </div>
          </Button>
        )}
        {!hasLogout && (
          <Button className="edit-button" onClick={() => handleModalOpen()}>
            <span className="edit-text">Tempo</span>
            <img
              src={editButton}
              className="edit-icon"
              alt="Ícone de um lápis usado para indicar botões de edição"
            />
          </Button>
        )}
        {!hasLogout && (
          <a
            href={`${process.env.REACT_APP_FIGHT_ADMIN}/lutas/${fight.id}/editar`}
            target="_blank"
            rel="noopener noreferrer"
            className="edit-button"
          >
            <span className="edit-text">Luta</span>

            <img
              src={editButton}
              className="edit-icon"
              alt="Ícone de um lápis usado para indicar botões de edição"
            />
          </a>
        )}
        {!hasLogout && (
          <CustomLink to={`/events/${fight.eventId}/fights`}>
            <span className="close-icon" />
            <span className="close-text">Fechar</span>
          </CustomLink>
        )}
      </div>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={handleCloseModal}
        style={customStyles as Styles}
        contentLabel="Fight Update Time Modal"
      >
        <ModalTitle>
          <div className="title">
            <h2> ATUALIZAÇÃO DE TEMPO</h2>
          </div>
        </ModalTitle>

        <ModalContent>
          <div className="update-time">
            <IMaskInput
              type="text"
              className="update-time-input"
              inputRef={updateTime}
              placeholder="Tempo"
              mask="00:00"
              value={updateTime?.current?.value}
            />
          </div>
        </ModalContent>

        <ModalContent>
          <Button
            style={{
              width: '184px',
              height: '46px',
              color: 'rgba(1, 128, 199, 1)',
            }}
            onClick={handleCloseModal}
          >
            Fechar
          </Button>
          <Button
            style={{
              width: '184px',
              height: '46px',
              background: 'rgba(1, 128, 199, 1)',
              color: '#FFF',
            }}
            onClick={handleEditTempo}
          >
            Atualizar tempo
          </Button>
        </ModalContent>
      </Modal>

      <Modal
        isOpen={modalIsOpenSwap}
        onRequestClose={handleCloseModalSwap}
        style={customStyles as Styles}
        contentLabel="Fight Swap Fighters Modal"
      >
        <ModalTitle>
          <div className="title">
            <h2> INVERTER LUTADORES</h2>
          </div>
        </ModalTitle>

        <ModalContent>
          <div className="inverter-lutadores content">
            Deseja inverter os lutadores?
          </div>
        </ModalContent>

        <ModalContent>
          <Button
            style={{
              width: '184px',
              height: '46px',
              color: 'rgba(1, 128, 199, 1)',
            }}
            onClick={handleCloseModalSwap}
          >
            Fechar
          </Button>
          <Button
            style={{
              width: '184px',
              height: '46px',
              background: 'rgba(1, 128, 199, 1)',
              color: '#FFF',
            }}
            onClick={handleSwapFighters}
          >
            Inverter lutadores
          </Button>
        </ModalContent>
      </Modal>
    </Container>
  );
};

export default RightHeader;
